export default "__VITE_ASSET__DpLV$vAE__"